import TweenMax, { Power2 } from "gsap/TweenMax";
import getOffset from "./getOffset";
import Sketch from './Sketch';
import LazyLoad from "vanilla-lazyload";

class Page{
    constructor(container){
        this.container = container;
        this.pageId = this.container.getAttribute('data-id');
        this.closeId = this.container.getAttribute('data-close');
        this.prevId = this.container.getAttribute('data-prev');
        this.nextId = this.container.getAttribute('data-next');
        this.leftId = this.container.getAttribute('data-left');
        this.rightId = this.container.getAttribute('data-right');
        this.outDelay = this.container.getAttribute('data-out')?parseInt(this.container.getAttribute('data-out'),0):0;
        this.busy = false;
        this.busyAnimation = false;

        this.init();
    }

    init(){
        const cmp = this;

        const elements = cmp.container.getElementsByClassName('j-page-element');
        let elementMass = [];
        for(let i=0; i<elements.length; i++){
            elementMass.push({});
        }
        for(let i=0; i<elements.length; i++){
            elementMass[parseInt(elements[i].getAttribute('data-step'),0)] = {
                'el': elements[i]
            }
        }

        const tryLoad = function(){
            if(!cmp.busyAnimation){
                cmp.busyAnimation = true;
                let i=0;
                while(i<elementMass.length){
                    let h = parseFloat(Math.max(document.documentElement.clientHeight, window.innerHeight || 0),0);
                    let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
                    if(getOffset(elementMass[i].el).top + parseFloat(Math.max(elementMass[i].el.clientHeight, elementMass[i].el.innerHeight || 0),0)*0.5 <= h){
                        if(!elementMass[i].el.classList.contains('_init')){
                            elementMass[i].el.classList.add('_init');
                            i=elementMass.length;
                            setTimeout(function(){
                                cmp.busyAnimation = false;
                                tryLoad();
                            }, (w < 1023 && document.body.classList.contains('_wide'))?10:450);
                        }
                    }
                    i++;
                }
                if(i === elementMass.length){
                    cmp.busyAnimation = false;
                }
            }
        }

        const observer = new IntersectionObserver(function(entries) {
            if(entries[0].isIntersecting === true && !document.querySelector('.touchevents')){
                new Sketch(entries[0].target.id);
                console.log('vis')
            }
            else{ 
                console.log('invis')
                if(document.querySelector(".no-touchevents .j-gl canvas")){
                    var canvas = document.querySelector(".no-touchevents .j-gl canvas");
                    var gl = canvas.getContext('webgl');
                    // canvas.addEventListener('webglcontextlost', function(e) {
                    //     console.log(e); 
                    // }, false);
                    gl.getExtension('WEBGL_lose_context').loseContext();
                    document.querySelector(".j-gl canvas").remove()
                }
            }
        }, { threshold: [0] });

        const videoObserver = new IntersectionObserver(function(entries) {
            if(entries[0].isIntersecting === false){
                console.log('invis', entries[0].target.id)
                document.querySelector('#' + entries[0].target.id + ' video').pause()
                // entries[0].target.getElementsByClassName('px-video-play')[0].classList.add('hide');
                // entries[0].target.getElementsByClassName('px-video-pause')[0].classList.add('hide');
                entries[0].target.getElementsByClassName('px-video-controls')[0].style = "transform: translateZ(0);";
                entries[0].target.getElementsByClassName('j-vid-play')[0].style = "display:block;";
                if(document.querySelector('._current .j-video')){
                    var player = videojs(document.querySelector('._current .j-video video').id.split("_")[0])
                    if(player.isFullscreen() && player.paused()){
                        player.play()
                    }
                }
                if(document.querySelector('._current .day-small-video__buy')){
                    entries[0].target.getElementsByClassName('day-small-video__buy')[0].style = "transform: translateZ(0);";
                }
                if(document.querySelector('._current .day-video__buy')){
                    entries[0].target.getElementsByClassName('day-video__buy')[0].style = "transform: translateZ(0);";
                }
            }
        }, { threshold: [0.65] });

        window.addEventListener('resize', function(){
            let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
            if(w < 1023 && document.body.classList.contains('_wide')){
                const days = document.getElementsByClassName('_current')[0].getElementsByClassName('j-days-inner');
                if(days.length > 0){
                    const cu = days[0].getElementsByClassName('_active')[0];
                    if(cu.offsetLeft > 108){
                        days[0].scrollLeft = cu.offsetLeft - 108;
                    }
                }
            }
            else{
                const days = document.getElementsByClassName('_current')[0].getElementsByClassName('j-days-inner');
                if(days.length > 0){
                    days[0].scrollLeft = 0;
                }
            }
            if(document.querySelector('._current #lighta')){
                document.querySelector('#lighta').style.height = document.querySelector(".page._current .page-content ").scrollHeight + 'px'
            }
            if(document.querySelector('._current #lightb')){
                document.querySelector('#lightb').style.height = document.querySelector(".page._current .page-content ").scrollHeight + 'px'
            }
            if(document.querySelector('._current #lightc')){
                document.querySelector('#lightc').style.height = document.querySelector(".page._current .page-content ").scrollHeight + 'px'
            }
            if(document.querySelector('._current #lightd')){
                document.querySelector('#lightd').style.height = document.querySelector(".page._current .page-content ").scrollHeight + 'px'
            }
        });

        document.addEventListener('page.load', function(e){
            if(document.querySelector(".touchevents ._current .lazy")){
                new LazyLoad({
                    elements_selector: "._current .lazy",
                    load_delay: 100
                });    
            }
            if(e.detail.current === cmp.pageId){
                const teaser = cmp.container.querySelectorAll('.j-teaser');
                if(teaser.length > 0){
                    if(document.querySelector('.touchevents')){
                        document.querySelector('._current .j-vid-play').classList.add('show_play')
                        var player = videojs(teaser[0], {
                            aspectRatio: '9:16',
                        })
                        player.src({src: 'https://dyatlov.ruptly.tv/web/videos/Eng_Intro_New/Eng_Intro_New_001/playlist_en.m3u8', type: 'application/x-mpegURL'})
                        player.play();
                        player.on('pause', function() {
                            document.querySelector('._current .j-vid-play').classList.add('show_play')
                        });
                        player.on('play', function() {
                            document.querySelector('._current .j-vid-play').classList.remove('show_play')
                        });
                    }else{
                        var player = videojs(teaser[0])
                        player.src({src: 'https://dyatlov.ruptly.tv/web/videos/Eng_Intro_New/Eng_Intro_New_003/playlist_en.m3u8', type: 'application/x-mpegURL'})
                        player.play();
                        player.on('pause', function() {
                            this.bigPlayButton.show();
                        });
                        player.on('play', function() {
                            this.bigPlayButton.hide();
                        });
                    }
                    teaser[0].onended = () => {
                        document.dispatchEvent(new CustomEvent('page.change',{'detail':{'current':'page02','direction':'next'}}));
                    }
                }
                let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
                if(w < 1023 && document.body.classList.contains('_wide')){
                    const days = document.getElementsByClassName('_current')[0].getElementsByClassName('j-days-inner');
                    if(days.length > 0){
                        const cu = days[0].getElementsByClassName('_active')[0];
                        if(cu.offsetLeft > 108){
                            days[0].scrollLeft = cu.offsetLeft - 108;
                        }
                    }
                }
                else{
                    const days = document.getElementsByClassName('_current')[0].getElementsByClassName('j-days-inner');
                    if(days.length > 0){
                        days[0].scrollLeft = 0;
                    }
                }

                setTimeout(tryLoad, 1200);
                document.addEventListener("wheel", tryLoad);
                document.addEventListener("mousewheel", tryLoad);
                document.addEventListener("DOMMouseScroll", tryLoad);
                document.addEventListener("touchmove", tryLoad);

                const videos = document.getElementsByClassName('_current')[0].getElementsByClassName('j-video');
                for(let i=0; i<videos.length; i++){
                    if(!videos[i].classList.contains('_vidinit')){
                        var player = videojs(videos[i].getElementsByTagName('video')[0])
                        player.on('fullscreenchange', function () {
                            console.log(player.isFullscreen())
                            if(player.isFullscreen() && !player.paused()){
                                player.pause()
                            }else if(!player.isFullscreen() && !player.paused()){
                                player.pause()
                            }
                        });
                        player.on('pause', function(){
                            document.querySelector('._current .j-vid-play').style = "display: block;"
                        });
                        videos[i].classList.add('_vidinit');
                        videos[i].getElementsByTagName('video')[0].onended = () => {
                            player.exitFullscreen()
                            //document.dispatchEvent(new CustomEvent('page.change',{'detail':{'current': cmp.pageId,'direction':'next'}}));
                        }
                        videoObserver.observe(videos[i])
                    }
                }
                const smallVideos = document.getElementsByClassName('_current')[0].getElementsByClassName('j-small-video');
                for(let i=0; i<smallVideos.length; i++){
                    if(!smallVideos[i].classList.contains('_vidinit')){
                        // new InitPxVideo({
                        //     "videoId": smallVideos[i].getAttribute('id'),
                        //     "captionsOnDefault": true,
                        //     "seekInterval": 20,
                        //     "videoTitle": "",
                        //     "debug": false
                        // });
                        videojs(smallVideos[i].getElementsByTagName('video')[0])
                        smallVideos[i].classList.add('_vidinit');
                        smallVideos[i].getElementsByTagName('video')[0].onended = () => {
                            smallVideos[i].getElementsByTagName('video')[0].currentTime = 0;
                            smallVideos[i].getElementsByTagName('video')[0].pause();
                            // if(smallVideos[i].getElementsByClassName('px-video-play').length > 0){                                
                            //     smallVideos[i].getElementsByClassName('px-video-play')[0].classList.remove('hide');
                            //     smallVideos[i].getElementsByClassName('px-video-pause')[0].classList.add('hide');
                            // }
                        }
                        videoObserver.observe(smallVideos[i])
                    }
                }
                
                let sidevid = document.getElementsByClassName('j-side-video');
                for(let i=0; i<sidevid.length; i++){
                    if(!sidevid[i].classList.contains('_vidinit')){
                        var player = videojs(sidevid[i].getElementsByTagName('video')[0])
                        console.log(videojs.getAllPlayers()[i].id_)
                        sidevid[i].classList.add('_vidinit');
                        sidevid[i].getElementsByTagName('video')[0].onended = () => {
                            sidevid[i].getElementsByTagName('video')[0].currentTime = 0;
                            sidevid[i].getElementsByTagName('video')[0].pause();
                        }
                        videoObserver.observe(sidevid[i])
                    }
                }


                let vidPlayFS = document.querySelector('._current .fs');
                if(vidPlayFS){
                    vidPlayFS.addEventListener('click', function(){
                        var player = videojs(vidPlayFS.parentElement.children[1].id)
                        player.requestFullscreen()
                        setTimeout(function(){player.play()}, 500)
                    });
                }
                if(e.detail.current == "page13" ){
                    observer.observe(document.querySelector("#day10image3d"));
                }
                // const sketches = document.getElementsByClassName('j-gl');
                // for(let i=0; i<sketches.length; i++){
                //     new Sketch(sketches[i].getAttribute('id'));
                // }
                if(e.detail.current == "page14a"){
                    var flashlight = document.querySelector('#lighta');
                    flashlight.style.height = document.querySelector(".page._current .page-content .last").scrollHeight + 'px'
                    window.addEventListener('mousemove', function(event) {
                        flashlight.style.backgroundPositionX = (event.pageX-2500) + 'px';
                        flashlight.style.backgroundPositionY = (event.pageY-2500) + 'px';
                    });
                }
                if(e.detail.current == "page14b"){
                    var flashlight = document.querySelector('#lightb');
                    flashlight.style.height = document.querySelector(".page._current .page-content .last").scrollHeight + 'px'
                    window.addEventListener('mousemove', function(event) {
                        flashlight.style.backgroundPositionX = (event.pageX-2500) + 'px';
                        flashlight.style.backgroundPositionY = (event.pageY-2500) + 'px';
                    });
                }
                if(e.detail.current == "page14c"){
                    var flashlight = document.querySelector('#lightc');
                    flashlight.style.height = document.querySelector(".page._current .page-content .last").scrollHeight + 'px'
                    window.addEventListener('mousemove', function(event) {
                        flashlight.style.backgroundPositionX = (event.pageX-2500) + 'px';
                        flashlight.style.backgroundPositionY = (event.pageY-2500) + 'px';
                    });
                }
                if(e.detail.current == "page14d"){
                    var flashlight = document.querySelector('#lightd');
                    flashlight.style.height = document.querySelector(".page._current .page-content .last").scrollHeight + 'px'
                    window.addEventListener('mousemove', function(event) {
                        flashlight.style.backgroundPositionX = (event.pageX-2500) + 'px';
                        flashlight.style.backgroundPositionY = (event.pageY-2500) + 'px';
                    });
                    var shareText = ""
                    var fbShare = ""
                    var vkShare = ""
                    var twShare = ""
                    if(document.querySelector('textarea')){
                        const textarea = document.querySelector("textarea");
                        
                        textarea.addEventListener("input", event => {
                            const target = event.currentTarget;
                            const maxLength = 280;
                            const currentLength = target.value.length;
                            if (currentLength >= maxLength) {
                                return console.log("You have reached the maximum number of characters.");
                            }
                            shareText = target.value
                            console.log(`${maxLength - currentLength} chars left`);
                        });
                        fbShare = 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Falert.ruptly.tv%2Fanton%2Ftests%2Fdyatlov_eng%2Findex.html&quote=' + encodeURIComponent(shareText) + '&display=popup'
                        vkShare = 'https://oauth.vk.com/authorize?client_id=-1&redirect_uri=https%3A%2F%2Fvk.com%2Fshare.php%3Furl%3Dhttps%3A%2F%2Falert.ruptly.tv%2Fanton%2Ftests%2Fdyatlov_eng%2Findex.html&description=' + encodeURIComponent(shareText) + '&display=widget'
                        twShare = 'https://twitter.com/intent/tweet?url=https%3A%2F%2Falert.ruptly.tv%2Fanton%2Ftests%2Fdyatlov_eng%2Findex.html&text=' + encodeURIComponent(shareText)
                    }
                    document.querySelector('._current .last-share__item--fb').addEventListener('click', event =>{
                        window.open('https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Falert.ruptly.tv%2Fanton%2Ftests%2Fdyatlov_eng%2Findex.html&quote=' + encodeURIComponent(shareText) + '&display=popup','targetWindow','toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=350');
                    })
                    document.querySelector('._current .last-share__item--vk').addEventListener('click', event =>{
                        window.open('https://oauth.vk.com/authorize?client_id=-1&redirect_uri=https%3A%2F%2Fvk.com%2Fshare.php%3Furl%3Dhttps%3A%2F%2Falert.ruptly.tv%2Fanton%2Ftests%2Fdyatlov_eng%2Findex.html&description=' +encodeURIComponent(shareText)+ '&display=widget','targetWindow','toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=350');
                    })
                    document.querySelector('._current .last-share__item--tw').addEventListener('click', event =>{
                        window.open('https://twitter.com/intent/tweet?url=https%3A%2F%2Falert.ruptly.tv%2Fanton%2Ftests%2Fdyatlov_eng%2Findex.html&text=' + encodeURIComponent(shareText),'targetWindow','toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=350');
                    })
                }
            }
        });

        document.addEventListener('page.unload', function(e){
            if(e.detail.current === cmp.pageId){
                document.removeEventListener("wheel", tryLoad);
                document.removeEventListener("mousewheel", tryLoad);
                document.removeEventListener("DOMMouseScroll", tryLoad);
                document.removeEventListener("touchmove", tryLoad);
                for(let i=0; i<elementMass.length; i++){
                    elementMass[i].el.classList.remove('_init');
                }
                cmp.busyAnimation = false;
            }
            if(e.detail.current == "page13"){
                if(document.querySelector("#day10image3d")){
                    observer.unobserve(document.querySelector("#day10image3d"));
                    var canvas = document.querySelector(".j-gl canvas");
                    var gl = canvas.getContext('webgl');
                    canvas.addEventListener('webglcontextlost', function(e) {
                        console.log(e); 
                    }, false);
                    gl.getExtension('WEBGL_lose_context').loseContext();
                    document.querySelector(".j-gl canvas").remove()
                }
            }
        });

        document.addEventListener('page.change', function(e){
            if(e.detail.current === cmp.pageId){
                let dela = 1;
                if(document.getElementsByClassName('j-side')[0].classList.contains('_opened')){
                    document.dispatchEvent(new Event('side.close'));
                    dela = 500;
                }
                setTimeout(function(){
                    const teaser = cmp.container.getElementsByClassName('j-teaser');
                    if(teaser.length > 0){
                        videojs(teaser[0]).pause();
                    }
                    const videos = document.getElementsByClassName('_current')[0].getElementsByClassName('j-video');
                    for(let i=0; i<videos.length; i++){
                        videos[i].getElementsByTagName('video')[0].pause();
                        if(videos[i].getElementsByClassName('px-video-play').length > 0){
                            videos[i].getElementsByClassName('px-video-play')[0].classList.remove('hide');
                            videos[i].getElementsByClassName('px-video-pause')[0].classList.add('hide');
                        }
                    }
                    const smallVideos = document.getElementsByClassName('_current')[0].getElementsByClassName('j-small-video');
                    for(let i=0; i<smallVideos.length; i++){
                        smallVideos[i].getElementsByTagName('video')[0].onended = () => {
                            smallVideos[i].getElementsByTagName('video')[0].pause();
                            if(smallVideos[i].getElementsByClassName('px-video-play').length > 0){
                                smallVideos[i].getElementsByClassName('px-video-play')[0].classList.remove('hide');
                                smallVideos[i].getElementsByClassName('px-video-pause')[0].classList.add('hide');
                            }
                        }
                    }
                    switch(e.detail.direction){
                        case 'next': {
                            if(!cmp.busy){
                                const current = cmp.container;
                                const next = document.getElementById(cmp.container.getAttribute('data-next'));
                                const helper = document.getElementsByClassName('j-helper-page')[0];
                                if(next){
                                    cmp.busy = true;
                                    current.classList.add('_animation-out');
                                    TweenMax.fromTo(
                                        '.j-helper-page',
                                        0.5,
                                        {
                                            display: 'block',
                                            height: 0,
                                            opacity: 1
                                        },
                                        {
                                            display: 'block',
                                            height: '100%',
                                            ease: Power2.easeOut,
                                            delay: 0.05 + cmp.outDelay/1000,
                                            opacity: 1,
                                            onComplete: () => {
                                                if(teaser.length > 0){
                                                    teaser[0].currentTime = 0;
                                                }
                                                for(let i=0; i<videos.length; i++){
                                                    videos[i].getElementsByTagName('video')[0].currentTime = 0;
                                                }
                                                for(let i=0; i<smallVideos.length; i++){
                                                    smallVideos[i].getElementsByTagName('video')[0].currentTime = 0;
                                                }
                                                if(document.querySelector('._current .day-to-prev-desk')){
                                                    document.querySelector('._current .day-to-prev-desk').scrollIntoView(true)
                                                }
                                                current.classList.remove('_current');
                                                current.classList.remove('_animation-in');
                                                current.classList.remove('_animation-out');
                                                current.removeAttribute('style');
                                                helper.classList.add('_current');
                                                document.dispatchEvent(new CustomEvent('page.unload', {'detail': {'current': cmp.pageId}}));

                                                if(next.getElementsByClassName('j-page-content').length > 0){
                                                    next.getElementsByClassName('j-page-content')[0].scrollTop = 0
                                                }
                                                if(next.getElementsByClassName('j-gallery-scrollable').length > 0){
                                                    document.dispatchEvent(new Event('gallery.toStart'));
                                                }
                                                if(next.getElementsByClassName('j-music-start').length > 0){
                                                    document.dispatchEvent(new Event('music.start'));
                                                }

                                                TweenMax.fromTo(
                                                    `#${cmp.container.getAttribute('data-next')}`,
                                                    0.5,
                                                    {
                                                        display: 'block',
                                                        height: 0,
                                                        opacity: 1
                                                    },
                                                    {
                                                        ease: Power2.easeOut,
                                                        display: 'block',
                                                        height: '100%',
                                                        opacity: 1,
                                                        onComplete: () => {
                                                            helper.removeAttribute('style');
                                                            helper.classList.remove('_current');
                                                            next.classList.add('_current');
                                                            next.classList.add('_animation-in');
                                                            cmp.busy = false;
                                                            document.dispatchEvent(new CustomEvent('page.load', {'detail': {'current': cmp.container.getAttribute('data-next')}}));
                                                        }
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }
                            }

                            break;
                        }
                        case 'to': {
                            if(!cmp.busy){
                                const current = cmp.container;
                                const next = document.getElementById(e.detail.towhat);
                                const helper = document.getElementsByClassName('j-helper-page')[0];
                                if(next){
                                    cmp.busy = true;
                                    current.classList.add('_animation-out');
                                    TweenMax.fromTo(
                                        '.j-helper-page',
                                        0.5,
                                        {
                                            display: 'block',
                                            height: 0,
                                            opacity: 1
                                        },
                                        {
                                            ease: Power2.easeOut,
                                            delay: 0.05 + cmp.outDelay/1000,
                                            display: 'block',
                                            height: '100%',
                                            opacity: 1,
                                            onComplete: () => {
                                                if(teaser.length > 0){
                                                    teaser[0].currentTime = 0;
                                                }
                                                for(let i=0; i<videos.length; i++){
                                                    videos[i].getElementsByTagName('video')[0].currentTime = 0;
                                                }
                                                for(let i=0; i<smallVideos.length; i++){
                                                    smallVideos[i].getElementsByTagName('video')[0].currentTime = 0;
                                                }
                                                if(document.querySelector('._current .day-to-prev-desk')){
                                                    document.querySelector('._current .day-to-prev-desk').scrollIntoView(true)
                                                }
                                                current.classList.remove('_current');
                                                current.classList.remove('_animation-in');
                                                current.classList.remove('_animation-out');
                                                current.removeAttribute('style');
                                                helper.classList.add('_current');
                                                document.dispatchEvent(new CustomEvent('page.unload', {'detail': {'current': cmp.pageId}}));

                                                if(next.getElementsByClassName('j-page-content').length > 0){
                                                    next.getElementsByClassName('j-page-content')[0].scrollTop = 0
                                                }
                                                if(next.getElementsByClassName('j-gallery-scrollable').length > 0){
                                                    document.dispatchEvent(new Event('gallery.toStart'));
                                                }

                                                TweenMax.fromTo(
                                                    `#${e.detail.towhat}`,
                                                    0.5,
                                                    {
                                                        display: 'block',
                                                        height: 0,
                                                        opacity: 1
                                                    },
                                                    {
                                                        ease: Power2.easeOut,
                                                        display: 'block',
                                                        height: '100%',
                                                        opacity: 1,
                                                        onComplete: () => {
                                                            helper.removeAttribute('style');
                                                            helper.classList.remove('_current');
                                                            next.classList.add('_current');
                                                            next.classList.add('_animation-in');
                                                            if(next.getElementsByClassName('_current-photo').length > 0){
                                                                next.getElementsByClassName('_current-photo')[0].classList.add('_ani-in');
                                                            }
                                                            cmp.busy = false;
                                                            document.dispatchEvent(new CustomEvent('page.load', {'detail': {'current': e.detail.towhat}}));
                                                        }
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }
                            }

                            break;
                        }
                        case 'prev': {
                            if(!cmp.busy){
                                const current = cmp.container;
                                const prev = document.getElementById(cmp.container.getAttribute('data-prev'));
                                const helper = document.getElementsByClassName('j-helper-page')[0];
                                if(prev){
                                    cmp.busy = true;
                                    current.classList.add('_animation-out');
                                    TweenMax.fromTo(
                                        '.j-helper-page',
                                        0.5,
                                        {
                                            display: 'block',
                                            height: 0,
                                            top: 0,
                                            opacity: 1,
                                            bottom: 'auto'
                                        },
                                        {
                                            display: 'block',
                                            height: '100%',
                                            top: 0,
                                            opacity: 1,
                                            bottom: 'auto',
                                            ease: Power2.easeOut,
                                            delay: 0.05 + cmp.outDelay/1000,
                                            onComplete: () => {
                                                if(teaser.length > 0){
                                                    teaser[0].currentTime = 0;
                                                }
                                                for(let i=0; i<videos.length; i++){
                                                    videos[i].getElementsByTagName('video')[0].currentTime = 0;
                                                }
                                                for(let i=0; i<smallVideos.length; i++){
                                                    smallVideos[i].getElementsByTagName('video')[0].currentTime = 0;
                                                }
                                                current.classList.remove('_current');
                                                current.classList.remove('_animation-in');
                                                current.classList.remove('_animation-out');
                                                current.removeAttribute('style');
                                                helper.classList.add('_current');
                                                document.dispatchEvent(new CustomEvent('page.unload', {'detail': {'current': cmp.pageId}}));

                                                if(prev.getElementsByClassName('j-page-content').length > 0){
                                                    prev.getElementsByClassName('j-page-content')[0].scrollTop = 0
                                                }
                                                if(prev.getElementsByClassName('j-gallery-scrollable').length > 0){
                                                    document.dispatchEvent(new Event('gallery.toStart'));
                                                }

                                                TweenMax.fromTo(
                                                    `#${cmp.container.getAttribute('data-prev')}`,
                                                    0.5,
                                                    {
                                                        display: 'block',
                                                        height: 0,
                                                        top: 0,
                                                        opacity: 1,
                                                        bottom: 'auto'
                                                    },
                                                    {
                                                        ease: Power2.easeOut,
                                                        display: 'block',
                                                        height: '100%',
                                                        top: 0,
                                                        opacity: 1,
                                                        bottom: 'auto',
                                                        onComplete: () => {
                                                            helper.removeAttribute('style');
                                                            helper.classList.remove('_current');
                                                            prev.classList.add('_current');
                                                            prev.classList.add('_animation-in');
                                                            cmp.busy = false;
                                                            document.dispatchEvent(new CustomEvent('page.load', {'detail': {'current': cmp.container.getAttribute('data-prev')}}));
                                                        }
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }
                            }

                            break;
                        }
                        case 'close': {
                            if(!cmp.busy){
                                const current = cmp.container;
                                const prev = document.getElementById(cmp.closeId);
                                const helper = document.getElementsByClassName('j-helper-page')[0];
                                if(prev){
                                    cmp.busy = true;
                                    current.classList.add('_animation-out');
                                    TweenMax.fromTo(
                                        '.j-helper-page',
                                        0.5,
                                        {
                                            display: 'block',
                                            height: 0,
                                            top: 0,
                                            opacity: 1,
                                            bottom: 'auto'
                                        },
                                        {
                                            display: 'block',
                                            height: '100%',
                                            top: 0,
                                            opacity: 1,
                                            bottom: 'auto',
                                            ease: Power2.easeOut,
                                            delay: 0.05 + cmp.outDelay/1000,
                                            onComplete: () => {
                                                if(teaser.length > 0){
                                                    teaser[0].currentTime = 0;
                                                }
                                                for(let i=0; i<videos.length; i++){
                                                    videos[i].getElementsByTagName('video')[0].currentTime = 0;
                                                }
                                                for(let i=0; i<smallVideos.length; i++){
                                                    smallVideos[i].getElementsByTagName('video')[0].currentTime = 0;
                                                }
                                                current.classList.remove('_current');
                                                current.classList.remove('_animation-in');
                                                current.classList.remove('_animation-out');
                                                current.removeAttribute('style');
                                                helper.classList.add('_current');
                                                document.dispatchEvent(new CustomEvent('page.unload', {'detail': {'current': cmp.pageId}}));

                                                if(prev.getElementsByClassName('j-page-content').length > 0){
                                                    prev.getElementsByClassName('j-page-content')[0].scrollTop = 0
                                                }
                                                if(prev.getElementsByClassName('j-gallery-scrollable').length > 0){
                                                    document.dispatchEvent(new Event('gallery.toStart'));
                                                }

                                                TweenMax.fromTo(
                                                    `#${cmp.closeId}`,
                                                    0.5,
                                                    {
                                                        display: 'block',
                                                        height: 0,
                                                        top: 0,
                                                        opacity: 1,
                                                        bottom: 'auto'
                                                    },
                                                    {
                                                        ease: Power2.easeOut,
                                                        display: 'block',
                                                        height: '100%',
                                                        top: 0,
                                                        opacity: 1,
                                                        bottom: 'auto',
                                                        onComplete: () => {
                                                            helper.removeAttribute('style');
                                                            helper.classList.remove('_current');
                                                            prev.classList.add('_current');
                                                            prev.classList.add('_animation-in');
                                                            cmp.busy = false;
                                                            document.dispatchEvent(new CustomEvent('page.load', {'detail': {'current': cmp.closeId}}));
                                                        }
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }
                            }

                            break;
                        }
                        case 'left': {
                            if(!cmp.busy){
                                const current = cmp.container;
                                const left = document.getElementById(cmp.leftId);
                                if(left){
                                    cmp.busy = true;
                                    left.setAttribute('data-right', cmp.pageId);
                                    if(left.getElementsByClassName('j-page-content').length > 0){
                                        left.getElementsByClassName('j-page-content')[0].scrollTop = 0
                                    }
                                    if(left.getElementsByClassName('j-gallery-scrollable').length > 0){
                                        document.dispatchEvent(new Event('gallery.toStart'));
                                    }
                                    TweenMax.fromTo(
                                        `#${cmp.leftId}`,
                                        0.5,
                                        {
                                            display: 'block',
                                            width: 0,
                                            height: '100%',
                                            opacity: 1,
                                            left: 'auto'
                                        },
                                        {
                                            display: 'block',
                                            width: '100%',
                                            height: '100%',
                                            opacity: 1,
                                            left: 'auto',
                                            ease: Power2.easeOut,
                                            onComplete: () => {
                                                current.classList.remove('_current');
                                                current.classList.remove('_animation-in');
                                                current.removeAttribute('style');
                                                left.classList.add('_current');
                                                left.classList.add('_animation-in');
                                                cmp.busy = false;
                                            }
                                        }
                                    );
                                }
                            }

                            break;
                        }
                        case 'unleft': {
                            if(!cmp.busy){
                                const current = cmp.container;
                                const right = document.getElementById(cmp.container.getAttribute('data-right'));
                                if(right){
                                    cmp.busy = true;
                                    right.classList.add('_current');
                                    TweenMax.fromTo(
                                        `#${cmp.pageId}`,
                                        0.5,
                                        {
                                            display: 'block',
                                            width: '100%',
                                            height: '100%',
                                            opacity: 1,
                                            left: 'auto'
                                        },
                                        {
                                            display: 'block',
                                            width: '0',
                                            height: '100%',
                                            opacity: 1,
                                            left: 'auto',
                                            ease: Power2.easeOut,
                                            onComplete: () => {
                                                current.classList.remove('_current');
                                                current.classList.remove('_animation-in');
                                                current.removeAttribute('style');
                                                
                                                right.classList.add('_animation-in');
                                                cmp.busy = false;
                                            }
                                        }
                                    );
                                }
                            }

                            break;
                        }
                        case 'right': {
                            if(!cmp.busy){
                                const current = cmp.container;
                                const right = document.getElementById(cmp.rightId);
                                if(right){
                                    cmp.busy = true;
                                    right.setAttribute('data-right', cmp.pageId);
                                    if(right.getElementsByClassName('j-page-content').length > 0){
                                        right.getElementsByClassName('j-page-content')[0].scrollTop = 0
                                    }
                                    if(right.getElementsByClassName('j-gallery-scrollable').length > 0){
                                        document.dispatchEvent(new Event('gallery.toStart'));
                                    }
                                    TweenMax.fromTo(
                                        `#${cmp.rightId}`,
                                        0.5,
                                        {
                                            display: 'block',
                                            width: 0,
                                            height: '100%',
                                            opacity: 1,
                                            left: 'auto'
                                        },
                                        {
                                            display: 'block',
                                            width: '100%',
                                            height: '100%',
                                            opacity: 1,
                                            left: 'auto',
                                            ease: Power2.easeOut,
                                            onComplete: () => {
                                                current.classList.remove('_current');
                                                current.classList.remove('_animation-in');
                                                current.removeAttribute('style');
                                                right.classList.add('_current');
                                                right.classList.add('_animation-in');
                                                cmp.busy = false;
                                            }
                                        }
                                    );
                                }
                            }

                            break;
                        }
                        case 'unright': {
                            if(!cmp.busy){
                                const current = cmp.container;
                                const left = document.getElementById(cmp.container.getAttribute('data-left'));
                                if(left){
                                    cmp.busy = true;
                                    left.classList.add('_current');
                                    TweenMax.fromTo(
                                        `#${cmp.pageId}`,
                                        0.5,
                                        {
                                            display: 'block',
                                            width: '100%',
                                            height: '100%',
                                            opacity: 1,
                                            left: 'auto'
                                        },
                                        {
                                            display: 'block',
                                            width: '0',
                                            height: '100%',
                                            opacity: 1,
                                            left: 'auto',
                                            ease: Power2.easeOut,
                                            onComplete: () => {
                                                current.classList.remove('_current');
                                                current.classList.remove('_animation-in');
                                                current.removeAttribute('style');
                                                
                                                left.classList.add('_animation-in');
                                                cmp.busy = false;
                                            }
                                        }
                                    );
                                }
                            }

                            break;
                        }
                        default: {
                            
                        }
                    }
                }, dela);
            }
        });
    }
}

export default Page;